import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/otherCost'


export function getAllOtherCostBytype(
  obj
) {
  return request({
    url:`${BASE_REQUEST}/getAllOtherCostBytype`,
    data:obj
  })
}
export function updateOtherCost(
  obj
) {
  return request({
    url:`${BASE_REQUEST}/updateOtherCost`,
    data:obj
  })
}
export function saveOtherCost(
  obj
) {
  return request({
    url:`${BASE_REQUEST}/saveOtherCost`,
    data:obj
  })
}

export function getOtherCostStandingBook(querydata) {
  return request({
    url:`${BASE_REQUEST}/getOtherCostStandingBook`,
    data:querydata
  })
}
